import { FunctionComponent } from 'react'
import { HeroSVGProps } from '@/components/HeroIcons/icon-types'
import { useTheme } from '@emotion/react'

const Headphone: FunctionComponent<HeroSVGProps> = ({
  themeColor,
  ...rest
}) => {
  const theme = useTheme()
  return (
    <svg
      {...rest}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 11.12C17.8622 11.12 17.75 11.2322 17.75 11.37V16.37C17.75 16.5078 17.8622 16.62 18 16.62H19C19.6908 16.62 20.25 16.0608 20.25 15.37V12.37C20.25 11.6792 19.6908 11.12 19 11.12H18ZM16.25 11.37C16.25 10.4038 17.0338 9.62 18 9.62H19C20.5192 9.62 21.75 10.8508 21.75 12.37V15.37C21.75 16.8892 20.5192 18.12 19 18.12H18C17.0338 18.12 16.25 17.3362 16.25 16.37V11.37Z"
        fill={theme.colors[themeColor[0]][themeColor[1]]}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 11.12C4.30921 11.12 3.75 11.6792 3.75 12.37V15.37C3.75 16.0608 4.30921 16.62 5 16.62H6C6.13779 16.62 6.25 16.5078 6.25 16.37V11.37C6.25 11.2322 6.13779 11.12 6 11.12H5ZM2.25 12.37C2.25 10.8508 3.48079 9.62 5 9.62H6C6.96621 9.62 7.75 10.4038 7.75 11.37V16.37C7.75 17.3362 6.96621 18.12 6 18.12H5C3.48079 18.12 2.25 16.8892 2.25 15.37V12.37Z"
        fill={theme.colors[themeColor[0]][themeColor[1]]}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.75 9.87C4.75 5.86578 7.99579 2.62 12 2.62C16.0042 2.62 19.25 5.86578 19.25 9.87V10.37C19.25 10.7842 18.9142 11.12 18.5 11.12C18.0858 11.12 17.75 10.7842 17.75 10.37V9.87C17.75 6.69421 15.1758 4.12 12 4.12C8.82421 4.12 6.25 6.69421 6.25 9.87V10.37C6.25 10.7842 5.91421 11.12 5.5 11.12C5.08579 11.12 4.75 10.7842 4.75 10.37V9.87Z"
        fill={theme.colors[themeColor[0]][themeColor[1]]}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.375 19.87C11.0992 19.87 10.875 20.0942 10.875 20.37C10.875 20.6458 11.0992 20.87 11.375 20.87H12.625C12.9008 20.87 13.125 20.6458 13.125 20.37C13.125 20.0942 12.9008 19.87 12.625 19.87H11.375ZM9.375 20.37C9.375 19.2658 10.2708 18.37 11.375 18.37H12.625C13.7292 18.37 14.625 19.2658 14.625 20.37C14.625 21.4742 13.7292 22.37 12.625 22.37H11.375C10.2708 22.37 9.375 21.4742 9.375 20.37Z"
        fill={theme.colors[themeColor[0]][themeColor[1]]}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 16.62C18.4142 16.62 18.75 16.9558 18.75 17.37V18.37C18.75 19.8892 17.5192 21.12 16 21.12H13.875C13.4608 21.12 13.125 20.7842 13.125 20.37C13.125 19.9558 13.4608 19.62 13.875 19.62H16C16.6908 19.62 17.25 19.0608 17.25 18.37V17.37C17.25 16.9558 17.5858 16.62 18 16.62Z"
        fill={theme.colors[themeColor[0]][themeColor[1]]}
      />
    </svg>
  )
}

export default Headphone
